import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import isNull from "lodash/isNull";
import omitBy from "lodash/omitBy";
import { getConfigValue } from "@jutro/config";
import { getBrowserLanguage, getCountryCodeFromLocale } from "./locale";
var DEFAULT_LOCALE_SETTINGS = {
  availableLanguages: ["en"],
  availableLocales: ["en-US"],
  defaultCountryCode: "US",
  defaultCurrency: "USD",
  preferredLanguage: "en",
  preferredLocale: "en-US"
};
export var getTimeZoneFallback = function () {
  var _Intl, _Intl$DateTimeFormat$, _Intl$DateTimeFormat;
  return (null === (_Intl = Intl) || void 0 === _Intl || null === (_Intl$DateTimeFormat$ = (_Intl$DateTimeFormat = _Intl.DateTimeFormat()).resolvedOptions) || void 0 === _Intl$DateTimeFormat$ ? void 0 : _Intl$DateTimeFormat$.call(_Intl$DateTimeFormat).timeZone) || "UTC";
};
function getLocaleConfig() {
  return _objectSpread(_objectSpread({}, DEFAULT_LOCALE_SETTINGS), {}, {
    defaultTimeZone: getTimeZoneFallback()
  }, omitBy(getConfigValue("localeSettings"), isNull));
}
export function getDefaultLanguages() {
  return getLocaleConfig().availableLanguages;
}
export function getDefaultLocales() {
  return getLocaleConfig().availableLocales;
}
export function getDefaultLanguage() {
  var browserLanguage = getBrowserLanguage(),
    availableLanguages = getDefaultLanguages();
  return _includesInstanceProperty(availableLanguages).call(availableLanguages, browserLanguage) ? browserLanguage : getLocaleConfig().preferredLanguage;
}
export function getDefaultLocale() {
  var browserLanguage = getBrowserLanguage(),
    availableLocales = getDefaultLocales();
  return _includesInstanceProperty(availableLocales).call(availableLocales, browserLanguage) ? browserLanguage : getLocaleConfig().preferredLocale;
}
export function getDefaultCountry() {
  return getCountryCodeFromLocale(getDefaultLocale()) || getLocaleConfig().defaultCountryCode;
}
export function getDefaultCurrency() {
  return getLocaleConfig().defaultCurrency;
}
export function getDefaultTimeZone() {
  return getLocaleConfig().defaultTimeZone;
}